// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import css from './vitrineProductDialog.css'
import VitrineProductForm from './VitrineProductForm'
import type { VitrineProduct } from './vitrineProductTypes'
type Props = {
  data: VitrineProduct | null | undefined
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class VitrineProductDialog extends React.PureComponent<Props> {
  render() {
    const { data, isOpen, onClose } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.vitrineProducts.products.title.editDialog')
            : i18n.t('admin.vitrineProducts.products.title.createDialog')}
        </DialogTitle>
        <DialogContent>
          <VitrineProductForm data={data} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default VitrineProductDialog
